var React = require('react');

function PinLocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9998 2.66602C10.8398 2.66602 6.6665 6.83935 6.6665 11.9993C6.6665 18.9993 15.9998 29.3327 15.9998 29.3327C15.9998 29.3327 25.3332 18.9993 25.3332 11.9993C25.3332 6.83935 21.1598 2.66602 15.9998 2.66602ZM15.9998 15.3327C14.1598 15.3327 12.6665 13.8393 12.6665 11.9993C12.6665 10.1593 14.1598 8.66602 15.9998 8.66602C17.8398 8.66602 19.3332 10.1593 19.3332 11.9993C19.3332 13.8393 17.8398 15.3327 15.9998 15.3327Z","fill":"#1B2B4C"}));
}

PinLocationInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PinLocationInline;

PinLocationInline.default = PinLocationInline;
